/**
 * Farbvorschau auf Produktkarten:
 * Klickt man auf ein Farbfeld, zeigt die Karte das Bild dieser Farbe an.
 * Die Zuordnung laeuft ueber den Alt-Text der Produktbilder (steht dort die Farbe).
 */

const COLOR_OPTION_NAMES = ['farbe', 'color', 'colour', 'couleur'];

/**
 * @param {Element} slide
 * @returns {string}
 */
const getSlideAlt = (slide) => (slide.querySelector('img')?.getAttribute('alt') || '').trim().toLowerCase();

/**
 * @param {Event} event
 */
function handleSwatchChange(event) {
  const input = event.target;
  if (!(input instanceof HTMLInputElement)) return;
  if (!input.name || !input.name.includes('-swatch')) return;

  const optionName = (input.dataset.optionName || '').trim().toLowerCase();
  if (optionName && !COLOR_OPTION_NAMES.includes(optionName)) return;

  const card = input.closest('product-card');
  const slideshow = card?.querySelector('slideshow-component');
  if (!card || !slideshow) return;

  const color = (input.value || '').trim().toLowerCase();
  if (!color) return;

  const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
  const colorSlides = slides.filter((slide) => slide.hasAttribute('variant-image'));
  if (colorSlides.length === 0) return;

  const target =
    colorSlides.find((slide) => getSlideAlt(slide) === color) ||
    colorSlides.find((slide) => getSlideAlt(slide).includes(color));

  if (!target) return;

  for (const slide of colorSlides) {
    const isTarget = slide === target;
    slide.hidden = !isTarget;
    slide.removeAttribute('reveal');
    slide.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
  }

  // Damit das Zuruecksetzen beim Verlassen der Karte wieder auf diese Farbe fuehrt.
  slideshow.setAttribute('initial-slide', String(slides.indexOf(target)));
}

// Capture-Phase, weil die Swatch-Komponente das Event sonst vorher abfaengt.
document.addEventListener('change', handleSwatchChange, true);
